import { useContext } from 'react';
import useUiRefs from '../../../hooks/useUiRefs';
import useFilterSetMenuItemByKey from '../../ProjectsFiltersBar/FilterSet/FilterSetMenu/useFilterSetMenuItemByKey';
import { FILTER_SET_MENU_KEYS } from '../../ProjectsFiltersBar/FilterSet/FilterSetMenu/useMenuItems';
import { isEmpty } from 'lodash';

const useMissingFiltersActions = Context => {
  const {
    state: { filterSets }
  } = useContext(Context);
  const { triggerFiltersMenuButtonRef } = useUiRefs(Context);
  const viewFilterSetsMenuItem = useFilterSetMenuItemByKey(
    Context,
    FILTER_SET_MENU_KEYS.VIEW
  );
  const shouldShowLoadFiltersButton = !isEmpty(filterSets);
  const shouldShowAddFiltersButton =
    triggerFiltersMenuButtonRef?.current?.offsetWidth > 0;

  const openFilterSetList = () => {
    viewFilterSetsMenuItem?.onClick();
  };

  const toggleFilterMenus = () => {
    triggerFiltersMenuButtonRef?.current.click();
  };

  return {
    openFilterSetList,
    toggleFilterMenus,
    shouldShowLoadFiltersButton,
    shouldShowAddFiltersButton
  };
};

export default useMissingFiltersActions;
